module.exports = __webpack_public_path__ + "img/SINGLE DEVICE SX PURPLE.1689ef5.svg";